// frontend/src/components/Login.js
import React from "react";
import { useSearchParams } from "react-router-dom";
import { OAuth2AuthCodePKCE } from "@bity/oauth2-auth-code-pkce";
import "./Login.css";
import { trackEvent } from "../utils/mixpanel";

function Login() {
  const LICHESS_HOST = "https://lichess.org";
  const clientId = "grandmasterai.com";
  const redirectUri = `${window.location.protocol}//${
    window.location.hostname
  }${
    window.location.port ? `:${window.location.port}` : ""
  }/auth-lichess-callback`; // Must match your backend & Lichess app settings
  const scopes = ["email:read"];

  const [searchParams] = useSearchParams();
  const errorParam = searchParams.get("error");

  // Function to get a user-friendly error message
  const getErrorMessage = (errorCode) => {
    switch (errorCode) {
      case "invalid_grant":
        return "Login failed: The authorization grant is invalid or expired. Please try again.";
      case "lichess_token_missing":
        return "Login failed: Could not retrieve token from Lichess. Please try again.";
      case "access_denied":
        return "Login failed: You denied access permissions on Lichess.";
      case "backend_login_failed":
        const status = searchParams.get("status");
        return `Login failed: Could not verify login with our server (Status: ${
          status || "Unknown"
        }). Please try again later.`;
      case "oauth_error": // Generic OAuth error from callback
      case "error_fetching_authorization_code": // Error from auth.fetchAuthorizationCode()
        return "An unexpected error occurred during Lichess login. Please try again.";
      default:
        return `An unknown error occurred (${errorCode}). Please try again.`;
    }
  };

  const auth = new OAuth2AuthCodePKCE({
    authorizationUrl: `${LICHESS_HOST}/oauth`,
    tokenUrl: `${LICHESS_HOST}/api/token`,
    clientId,
    scopes,
    redirectUrl: redirectUri,
  });

  const handleLogin = async () => {
    trackEvent("Login Attempted");
    try {
      await auth.fetchAuthorizationCode();
      trackEvent("Login Flow Started");
    } catch (error) {
      trackEvent("Login Failed", { error: error.message });
      console.error("Login error:", error);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <h1>Login to Grandmaster AI</h1>
        {errorParam && (
          <div className="error-message">{getErrorMessage(errorParam)}</div>
        )}
        <button
          id="lichess-login-button"
          className="lichess-button"
          onClick={handleLogin}
        >
          <img src="/imgs/lichess_logo.png" alt="Lichess Logo" />
          Login with Lichess
        </button>
      </div>
    </div>
  );
}

export default Login;
